import React from "react";

export default function TabNav({ tabs, active, onChange }) {
  return (
    <div style={styles.stickyWrap}>
      <nav
        className="km-tabnav-scroll"
        style={styles.nav}
        role="tablist"
        aria-label="Kundli sections"
      >
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(t.key)}
              className="km-tab"
              style={{ ...styles.tab, ...(isActive ? styles.tabActive : {}) }}
            >
              <span style={styles.icon}>{t.icon}</span>
              {t.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

const styles = {
  stickyWrap: {
    position: "sticky", top: 0, zIndex: 10,
    background: "var(--paper)",
    borderBottom: "1px solid var(--line)",
    padding: "14px 16px",
  },
  nav: {
    display: "flex", gap: 6,
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    maxWidth: 720, margin: "0 auto",
    scrollSnapType: "x proximity",
  },
  tab: {
    display: "inline-flex", alignItems: "center", gap: 7, flexShrink: 0,
    whiteSpace: "nowrap", scrollSnapAlign: "start",
    padding: "9px 16px", borderRadius: 999, border: "1px solid var(--line)",
    background: "var(--card)", color: "var(--ink-soft)", cursor: "pointer",
    fontSize: 13.5, fontWeight: 600, fontFamily: "var(--font-body)",
    transition: "all 0.18s var(--ease)",
  },
  tabActive: {
    background: "linear-gradient(135deg, var(--terracotta), var(--terracotta-dark))",
    color: "#fff", borderColor: "transparent",
    boxShadow: "0 8px 18px -8px rgba(216,98,43,0.55)",
  },
  icon: { fontSize: 14 },
};
